// Module
var code = "<div ng-if=\"$ctrl.shouldRenderAwardComponent\" class=\"hero-customizer-v3-award\"> <img ng-src=\"{{$ctrl.award.logoUrl}}?w=96&h=96&auto=format\" alt=\"{{$ctrl.award.endorser}}\"/> </div> ";
// Exports
module.exports = code;